import {HttpExclude, Request, RequestExpose} from '@simpli/serialized-request'
import {ExpansibleCollection} from '@simpli/resource-collection'
import {GithubRepositoryCommit} from '@/model/resource/GithubRepositoryCommit'

@HttpExclude()
export class GithubRepositoryCommitCollection extends ExpansibleCollection<
  GithubRepositoryCommit
> {
  resource?: IGithubRepositoryCommitCollectionResourcesHolder

  @RequestExpose() idOrganizationFk: number | null = null
  @RequestExpose() idGithubRepositoryFk: number | null = null

  constructor() {
    super(GithubRepositoryCommit)
  }

  queryAsPage() {
    return this.listGithubRepositoryCommit()
  }

  async listGithubRepositoryCommit() {
    return await Request.get(`/client/github-repository-commit`, {
      params: this.params,
    })
      .name('listGithubRepositoryCommit')
      .as(this)
      .getResponse()
  }

  async countByOrganization(): Promise<Record<number, number>> {
    return await Request.get(
      `/client/github-repository-commit/count-by-organization`
    )
      .name('countGithubRepositoryCommitByOrganization')
      .asAny()
      .getData()
  }

  async sumCommitsByOrganization(): Promise<number> {
    return await Request.get(
      `/client/github-repository-commit/sum-by-organization`,
      {
        params: this.params,
      }
    )
      .name('sumGithubRepositoryCommitByOrganization')
      .asNumber()
      .getData()
  }
}

export interface IGithubRepositoryCommitCollectionResourcesHolder {}
